import * as React from "react";
import { Market, Selection } from "../../../../../contracts";
import { SelectionBoxesCount } from "../../../../../data";
import { BetBtn } from "../../BetBtn";

export const renderOutrightBetButtons = (market: Market, betButtonHandler: (market: Market, selection: Selection) => void, componentPrefix: string) => {
    const selections = market.selections.slice(0, SelectionBoxesCount[`${market.template}`]);

    return (
        <div key={`${componentPrefix}__${market.id}`} className={`rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--${market.template}`} data-uat={`div-ev-list-${componentPrefix}-section`}>
            {selections && selections.map(
                (s, index) => {
                    let betslipModifier = s.isSelectionInBetslip ? "rj-ev-list__bet-btn--chosen" : "";

                    return (
                        <BetBtn
                            key={`${componentPrefix}__bet-btn__${market.id || "m"}-${s && s.id || "s"}-${index}`}
                            isDisabled={s.isDisabled}
                            classNames={`${betslipModifier}`}
                            handler={() => betButtonHandler(market as Market, s as Selection)}
                            text={s.name}
                            point={s.pointsText}
                            odd={s.odds}
                            trueOdds={s.trueOdds}
                        />
                    )
                }
            )}
        </div>
    );
}